import { Component, OnInit, Input, Inject } from '@angular/core';
import { ApiService } from './api.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dhhp-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss']
})
export class SubscriptionPlansComponent implements OnInit {

  @Input() config;

  appInfo = {};
  passedData: any;
  user: any;
  userName: String;
  planDetails: any;
  subscriptionPlans: Array<any> = [];
  index: number = 1;
  selectedIndex: number = -1;
  planType = 'monthlyPlan';
  planId: any = '';
  planName: any = '';
  plan: any = '';
  featureList: any = '';
  requestedPlan: any = '';
  selectedPlan = { subscriptionType: '' };
  indexVal: number;
  setChange: boolean = false;

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<SubscriptionPlansComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.planDetails = this.config.passedData;
    this.requestedPlan = this.config.requestedPlan,
      this.planId = this.config.planId;
    this.planName = this.config.planName;
    this.subscriptionPlans = this.config.subscriptionPlans[0].subscriptionPlans;
    this.user = JSON.parse(localStorage.getItem('userObject'));
    this.userName = JSON.parse(localStorage.getItem('userObject')).userId;
    this.plan = this.user.userAppSubscriptionDetails.filter(ele => ele.appId == this.planDetails.appKey);
    try {
      let features = JSON.parse(localStorage.getItem('featureList'));
      let featureListFiltered = features.filter(ele => ele.appId == this.planDetails.appId);
      this.featureList = featureListFiltered[0].applicationFeatures.appFeatureDetails.filter(ele => ele.languageCode == localStorage.getItem('Lang'));

    } catch (error) {

    }
    if (this.planId)
      this.selectedIndex = this.planId;
  }

  getFeatureName(data) {
    try {
      let name = this.featureList[0].appFeatureDescriptions.filter(ele => ele.id == data);
      return name.length > 0 ? name[0].name : data;
    } catch (error) {
      return data;
    }
  }
  planChange(value) {
    this.setChange = true;
    this.selectedPlan = this.subscriptionPlans.find((res, index) => {
      // this.selectedIndex = index;
      return res.planId == value
    });
    //this.selectedPlan.selectPlanView = true;
  }
  onCloseDialog(): void {
    this.dialogRef.close({ event: 'concentcancel' });
  }
  selectPlan() {
    this.selectedPlan.subscriptionType = this.planType;
    this.requestPlan(this.selectedPlan);
  }
  requestPlan(data) {
    let postParams = {
      formCRMId: this.plan[0].facilitySubscriptionDetails[0].facilityCRMId,
      formSAPId: this.plan[0].facilitySubscriptionDetails[0].facilitySAPId,
      appId: this.planDetails.appKey,
      updatedOn: data.updatedOn,
      userName: this.userName,
      isActive: data.isActive,
      facilityName: this.plan[0].facilitySubscriptionDetails[0].facilityName,
      requestedPlanId: data.planId,
      requestedPlanName: data.planName,
      monthlyCost: data.monthlyCost
    }
    this.dialogRef.close({ event: 'planSelected', data: postParams });
  }
  planTypeChange(event) {

  }
}
